
export default {
  props:{
    rows:{
      type:String,
      default:'2',
    },
    classes: {
      type:String,
      default:'bg-white p-0 pb-6 rounded-xl shadow-lg',
    },
    boxed: {
      type:String,
      default:'false',
    },
    cpd: {
      type:String,
      default:'member',
    },
    height: {
      type:String,
      default:'h-20',
    }
  },
}
